import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../public/img/Navigator/navIcon.png';
import _imports_1 from '../../../public/img/Navigator/heart.png';
const _hoisted_1 = {
  class: "navigator-list"
};
const _hoisted_2 = {
  class: "navigator-root"
};
const _hoisted_3 = {
  class: "navigator-car"
};
import { ref, onMounted, watch } from "vue";
import car from "./icon_cart.vue";
import iconPeople from "./icon_people.vue";
// import heart from './icon_heart.vue'

import { useRouter } from "vue-router";
export default {
  __name: 'common_nav',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const to = path => {
      router.push(path);
    };

    // 滑块相关数据
    const underlineLeft = ref(0);
    const underlineWidth = ref(0);
    const underlineVisible = ref(true); // 默认显示

    // 默认位置数据
    const defaultLeft = ref(0);
    const defaultWidth = ref(0);

    // 获取当前路由对应的导航项索引
    const getCurrentNavIndex = path => {
      if (path === "/") return 0;
      if (path.includes("/network")) return 3;
      if (path.includes("/daily")) return 2;
      if (path.includes("/encouragement")) return 1;
      // 可以根据需要添加其他路由匹配
      return 0; // 默认第一个
    };

    // 设置默认位置
    const setDefaultPosition = () => {
      const currentPath = router.currentRoute.value.path;
      const currentIndex = getCurrentNavIndex(currentPath);
      const navItems = document.querySelectorAll(".navigator-list-item");
      if (navItems[currentIndex]) {
        defaultLeft.value = navItems[currentIndex].offsetLeft;
        defaultWidth.value = navItems[currentIndex].offsetWidth;
        underlineLeft.value = defaultLeft.value;
        underlineWidth.value = defaultWidth.value;
      }
    };

    // 鼠标悬停时移动滑块
    const moveUnderline = event => {
      const element = event.currentTarget;
      underlineLeft.value = element.offsetLeft;
      underlineWidth.value = element.offsetWidth;
      underlineVisible.value = true;
    };

    // 鼠标离开时回到默认位置
    const hideUnderline = () => {
      underlineLeft.value = defaultLeft.value;
      underlineWidth.value = defaultWidth.value;
    };

    // 组件挂载后设置默认位置
    onMounted(() => {
      setTimeout(() => {
        setDefaultPosition();
      }, 100); // 延迟确保DOM已渲染
    });

    // 监听路由变化，更新默认位置
    watch(() => router.currentRoute.value.path, () => {
      setTimeout(() => {
        setDefaultPosition();
      }, 100);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["navigator", {
          compact: props.compact
        }])
      }, [_createElementVNode("div", {
        class: "navigator-logo",
        onClick: _cache[0] || (_cache[0] = $event => to('/'))
      }, _cache[10] || (_cache[10] = [_createElementVNode("img", {
        class: "navigator-logo-img",
        src: _imports_0,
        alt: ""
      }, null, -1)])), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "underline",
        style: _normalizeStyle({
          left: underlineLeft.value + 'px',
          width: underlineWidth.value + 'px',
          opacity: underlineVisible.value ? 1 : 0
        })
      }, null, 4), _createElementVNode("div", {
        class: "navigator-list-l1 navigator-list-item",
        onClick: _cache[1] || (_cache[1] = $event => to('/')),
        onMouseenter: _cache[2] || (_cache[2] = $event => moveUnderline($event)),
        onMouseleave: hideUnderline
      }, _cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "text"
      }, "EyesunRose", -1)]), 32), _createElementVNode("div", {
        class: "navigator-list-l2 navigator-list-item",
        onMouseenter: _cache[3] || (_cache[3] = $event => moveUnderline($event)),
        onMouseleave: hideUnderline,
        onClick: _cache[4] || (_cache[4] = $event => to('/encouragement'))
      }, _cache[12] || (_cache[12] = [_createElementVNode("div", {
        class: "text"
      }, "Encouragements", -1)]), 32), _createElementVNode("div", {
        class: "navigator-list-l3 navigator-list-item",
        onMouseenter: _cache[5] || (_cache[5] = $event => moveUnderline($event)),
        onMouseleave: hideUnderline,
        onClick: _cache[6] || (_cache[6] = $event => to('/daily'))
      }, _cache[13] || (_cache[13] = [_createElementVNode("div", {
        class: "text"
      }, "Daily Feeds", -1)]), 32), _createElementVNode("div", {
        class: "navigator-list-l4 navigator-list-item",
        onClick: _cache[7] || (_cache[7] = $event => to('/network')),
        onMouseenter: _cache[8] || (_cache[8] = $event => moveUnderline($event)),
        onMouseleave: hideUnderline
      }, _cache[14] || (_cache[14] = [_createElementVNode("div", {
        class: "text"
      }, "Network", -1)]), 32), _createElementVNode("div", {
        class: "navigator-list-l5 navigator-list-item",
        onMouseenter: _cache[9] || (_cache[9] = $event => moveUnderline($event)),
        onMouseleave: hideUnderline
      }, _cache[15] || (_cache[15] = [_createElementVNode("div", {
        class: "text"
      }, "Benefit Club", -1)]), 32)]), _createElementVNode("div", _hoisted_2, [_createVNode(iconPeople)]), _createElementVNode("div", _hoisted_3, [_createVNode(car)]), _cache[16] || (_cache[16] = _createElementVNode("div", {
        class: "navigator-collect"
      }, [_createElementVNode("img", {
        class: "navigator-collect-heart",
        src: _imports_1
      })], -1))], 2);
    };
  }
};